/* Toy Toing — scripts propios (sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Aparición al hacer scroll (un solo observador) ---------- */
  var observer = null;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.tt-reveal, .tt-desde-izq, .tt-observa');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('tt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tt-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { if (!el.classList.contains('tt-visible')) observer.observe(el); });
    // Red de seguridad: si se salta de golpe, muestra lo ya pasado
    if (!initReveal.escuchando) {
      initReveal.escuchando = true;
      var pendiente = false;
      window.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        setTimeout(function () {
          pendiente = false;
          document.querySelectorAll('.tt-reveal:not(.tt-visible), .tt-desde-izq:not(.tt-visible)').forEach(function (el) {
            if (el.getBoundingClientRect().top < window.innerHeight) {
              el.classList.add('tt-visible');
              if (observer) observer.unobserve(el);
            }
          });
        }, 250);
      }, { passive: true });
    }
  }

  /* ---------- Cifras que cuentan al aparecer ---------- */
  function initCifras(root) {
    (root || document).querySelectorAll('[data-tt-cuenta]').forEach(function (el) {
      if (el.dataset.ttListo) return;
      el.dataset.ttListo = '1';
      var fin = parseFloat(el.dataset.ttCuenta);
      var dec = (el.dataset.ttCuenta.split('.')[1] || '').length;
      if (isNaN(fin) || reduceMotion || !('IntersectionObserver' in window)) return;
      el.textContent = (0).toFixed(dec);
      var obs = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        var t0 = null, dur = 1400;
        function paso(t) {
          if (t0 === null) t0 = t;
          var p = Math.min(1, (t - t0) / dur);
          var e = 1 - Math.pow(1 - p, 3);
          el.textContent = (fin * e).toFixed(dec);
          if (p < 1) requestAnimationFrame(paso); else el.textContent = el.dataset.ttCuenta;
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.6 });
      obs.observe(el);
    });
  }

  /* ---------- Parallax suave del fondo del hero ---------- */
  function initParallax(root) {
    var els = Array.prototype.slice.call((root || document).querySelectorAll('[data-tt-parallax]'));
    if (!els.length || reduceMotion) return;
    els.forEach(function (el) {
      if (el.dataset.ttListo) return;
      el.dataset.ttListo = '1';
      var fuerza = parseFloat(el.dataset.ttParallax || '0.25');
      var pendiente = false;
      function mover() {
        pendiente = false;
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (-r.top * fuerza).toFixed(1) + 'px,0)';
      }
      window.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; requestAnimationFrame(mover); }
      }, { passive: true });
      mover();
    });
  }

  /* ---------- Carrusel sin fin: avance lento continuo + arrastre en ambos sentidos ---------- */
  function initContinuo(sec, pista) {
    var clones = pista.querySelectorAll('[data-tt-clon]');
    var primera = pista.querySelector('.tt-modelo, .tt-pill');
    if (!clones.length || !primera) return;
    var vel = parseFloat(pista.dataset.ttVel || '35');
    var pausaHover = pista.dataset.ttPausaHover === 'true' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var prev = sec.querySelector('[data-tt-prev]');
    var next = sec.querySelector('[data-tt-next]');
    var barra = sec.querySelector('.tt-progreso');
    if (barra) barra.style.display = 'none';
    var pos = 0, ultimo = null, encima = false, arrastrando = false, tocando = false;
    var reanudar = 0, inercia = 0, visible = true, tween = null;
    var x0 = 0, pos0 = 0, ultimoX = 0, ultimoT = 0, movido = 0;

    function mitad() { return clones[0].offsetLeft - primera.offsetLeft; }
    function paso() { return primera.getBoundingClientRect().width + (parseFloat(getComputedStyle(pista).columnGap) || 18); }
    function envolver() {
      var m = mitad(); if (m <= 0) return;
      while (pos >= m) pos -= m;
      while (pos < 0) pos += m;
    }
    function aplicar() { envolver(); pista.scrollLeft = pos; }
    function pausado() { return arrastrando || tocando || tween || (pausaHover && encima) || Date.now() < reanudar || !visible || document.hidden; }

    function bucle(t) {
      var dt = ultimo === null ? 0 : Math.min(0.1, (t - ultimo) / 1000);
      ultimo = t;
      if (inercia && !arrastrando) {
        pos += inercia * dt; inercia *= 0.93;
        if (Math.abs(inercia) < 8) inercia = 0;
        aplicar();
      } else if (!reduceMotion && !pausado()) {
        pos += vel * dt; aplicar();
      }
      requestAnimationFrame(bucle);
    }

    function deslizar(dist) {
      var inicio = pos, t0 = null, ms = reduceMotion ? 1 : 520;
      tween = true;
      function f(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - p, 3);
        pos = inicio + dist * e; aplicar();
        if (p < 1) requestAnimationFrame(f); else { tween = null; reanudar = Date.now() + 2500; }
      }
      requestAnimationFrame(f);
    }
    if (prev) prev.addEventListener('click', function () { if (!tween) deslizar(-paso()); });
    if (next) next.addEventListener('click', function () { if (!tween) deslizar(paso()); });

    // Desplazamiento propio del usuario (rueda, trackpad o dedo)
    pista.addEventListener('scroll', function () {
      if (arrastrando || tween) return;
      if (Math.abs(pista.scrollLeft - pos) < 2) return;
      pos = pista.scrollLeft;
      var m = mitad();
      if (pos >= m || pos < 1) aplicar();
      reanudar = Date.now() + 2000;
    }, { passive: true });

    pista.addEventListener('mouseenter', function () { encima = true; });
    pista.addEventListener('mouseleave', function () { encima = false; });
    pista.addEventListener('touchstart', function () { tocando = true; inercia = 0; }, { passive: true });
    pista.addEventListener('touchend', function () { tocando = false; reanudar = Date.now() + 2500; }, { passive: true });

    // Arrastrar con el ratón hacia ambos lados (con inercia)
    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      arrastrando = true; movido = 0; inercia = 0;
      x0 = ultimoX = e.clientX; pos0 = pos; ultimoT = e.timeStamp;
      e.preventDefault();
    });
    window.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      var dx = e.clientX - x0;
      movido = Math.max(movido, Math.abs(dx));
      // Solo es arrastre si el ratón se movió de verdad (si no, es un clic normal en la tarjeta)
      if (movido > 6) pista.classList.add('tt-arrastrando');
      var dt = Math.max(16, e.timeStamp - ultimoT);
      var v = -(e.clientX - ultimoX) / dt * 1000;
      inercia = Math.max(-1500, Math.min(1500, inercia * 0.6 + v * 0.4));
      ultimoX = e.clientX; ultimoT = e.timeStamp;
      pos = pos0 - dx; aplicar();
    });
    function soltar(e) {
      if (!arrastrando) return;
      arrastrando = false;
      pista.classList.remove('tt-arrastrando');
      if (Math.abs(inercia) < 60 || (e && e.timeStamp - ultimoT > 120)) inercia = 0;
      reanudar = Date.now() + 1500;
    }
    window.addEventListener('pointerup', soltar);
    window.addEventListener('pointercancel', soltar);
    // Si se arrastró, que no se abra la tarjeta al soltar
    pista.addEventListener('click', function (e) { if (movido > 6) { e.preventDefault(); e.stopPropagation(); movido = 0; } }, true);
    pista.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(pista);
    }
    window.addEventListener('resize', aplicar);
    pos = 0; aplicar();
    requestAnimationFrame(bucle);
  }

  /* ---------- Carrusel de modelos: flechas, arrastre y barra de progreso ---------- */
  function initCarrusel(root) {
    (root || document).querySelectorAll('[data-tt-carrusel]').forEach(function (sec) {
      if (sec.dataset.ttListo) return;
      sec.dataset.ttListo = '1';
      var pista = sec.querySelector('[data-tt-pista]');
      var prev = sec.querySelector('[data-tt-prev]');
      var next = sec.querySelector('[data-tt-next]');
      var barra = sec.querySelector('[data-tt-progreso]');
      if (!pista) return;
      if (pista.hasAttribute('data-tt-continuo')) { initContinuo(sec, pista); return; }
      function paso() { var c = pista.querySelector('.tt-modelo'); return c ? c.getBoundingClientRect().width + 18 : pista.clientWidth * 0.8; }
      function estado() {
        var max = pista.scrollWidth - pista.clientWidth;
        if (prev) prev.disabled = pista.scrollLeft <= 4;
        if (next) next.disabled = pista.scrollLeft >= max - 4;
        if (barra) {
          var visible = pista.clientWidth / pista.scrollWidth;
          barra.style.width = Math.max(8, visible * 100) + '%';
          var recorrido = max > 0 ? pista.scrollLeft / max : 0;
          barra.style.transform = 'translateX(' + (recorrido * (1 / Math.max(visible, .08) - 1) * 100) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { pista.scrollBy({ left: -paso(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { pista.scrollBy({ left: paso(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      pista.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();

      // Arrastrar con el ratón (en el móvil ya se desliza con el dedo)
      var abajo = false, x0 = 0, s0 = 0, movido = 0;
      pista.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        abajo = true; movido = 0; x0 = e.clientX; s0 = pista.scrollLeft;
      });
      window.addEventListener('pointermove', function (e) {
        if (!abajo) return;
        var dx = e.clientX - x0;
        movido = Math.max(movido, Math.abs(dx));
        if (movido > 5) pista.classList.add('tt-arrastrando');
        pista.scrollLeft = s0 - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!abajo) return;
        abajo = false;
        if (pista.classList.contains('tt-arrastrando')) {
          var p = paso();
          var destino = Math.round(pista.scrollLeft / p) * p;
          pista.classList.remove('tt-arrastrando');
          pista.scrollTo({ left: destino, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      });
      pista.addEventListener('click', function (e) { if (movido > 6) { e.preventDefault(); e.stopPropagation(); movido = 0; } }, true);
      pista.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- Pasos: resalta el paso que está en el centro ---------- */
  function initPasos(root) {
    (root || document).querySelectorAll('[data-tt-pasos]').forEach(function (sec) {
      if (sec.dataset.ttListo) return;
      sec.dataset.ttListo = '1';
      var pasos = sec.querySelectorAll('.tt-paso');
      if (!pasos.length || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) pasos.forEach(function (p) { p.classList.toggle('tt-activo', p === en.target); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(root) {
    (root || document).querySelectorAll('[data-tt-producto]').forEach(function (sec) {
      if (sec.dataset.ttListo) return;
      sec.dataset.ttListo = '1';

      var datosEl = sec.querySelector('[data-tt-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var form = sec.querySelector('.tt-form');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = sec.querySelector('[data-tt-add]');
      var botonTexto = boton ? boton.querySelector('[data-tt-add-texto]') : null;
      var textoComprar = boton ? boton.dataset.textoComprar : '';
      var textoAgotado = boton ? boton.dataset.textoAgotado : '';
      var precio = sec.querySelector('[data-tt-precio]');
      var precioAntes = sec.querySelector('[data-tt-precio-antes]');
      var ahorro = sec.querySelector('[data-tt-ahorro]');
      var barraPrecio = document.querySelector('[data-tt-barra-precio]');
      var barraAntes = document.querySelector('[data-tt-barra-antes]');
      var formato = sec.dataset.formatoDinero || '${{amount}}';
      var principal = sec.querySelector('[data-tt-principal]');
      var principalImg = principal ? principal.querySelector('img') : null;
      var contador = sec.querySelector('[data-tt-contador]');
      var minis = Array.prototype.slice.call(sec.querySelectorAll('[data-tt-mini]'));
      var indiceActual = Math.max(0, minis.findIndex(function (m) { return m.getAttribute('aria-current') === 'true'; }));

      function dinero(centavos) {
        var valor = (centavos / 100).toFixed(2);
        var partes = valor.split('.');
        var entero = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formato
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, entero)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, partes[0] + ',' + partes[1])
          .replace(/\{\{\s*amount\s*\}\}/, entero + '.' + partes[1]);
      }

      function mostrarMedia(i) {
        if (!minis.length || !principalImg) return;
        if (i < 0) i = minis.length - 1;
        if (i >= minis.length) i = 0;
        indiceActual = i;
        var mini = minis[i];
        minis.forEach(function (m) { m.setAttribute('aria-current', m === mini ? 'true' : 'false'); });
        if (contador) contador.textContent = (i + 1) + ' / ' + minis.length;
        var cont = mini.parentNode;
        if (window.innerWidth > 749) cont.scrollTop = mini.offsetTop - cont.offsetTop - 20;
        else cont.scrollLeft = mini.offsetLeft - cont.offsetLeft - 20;
        if (principalImg.getAttribute('src') === mini.dataset.src) return;
        principal.classList.add('tt-cambiando');
        setTimeout(function () {
          principalImg.src = mini.dataset.src;
          principalImg.srcset = mini.dataset.srcset || '';
          principalImg.alt = mini.dataset.alt || '';
          principal.classList.remove('tt-cambiando');
        }, reduceMotion ? 0 : 180);
      }
      // Al cambiar de foto con flechas, dedo o miniatura: elegir el modelo de esa foto en el selector
      function elegirModeloDeFoto() {
        var mini = minis[indiceActual];
        if (!mini) return;
        var v = variantes.find(function (x) { return x.featured_media && String(x.featured_media.id) === mini.dataset.mediaId; });
        if (!v) return;
        var actual = varianteSeleccionada();
        if (actual && actual.id === v.id) return;
        sec.querySelectorAll('[data-tt-opcion]').forEach(function (g, i) {
          g.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === v.options[i]; });
        });
        actualizar(v);
      }
      function irAFoto(i) { mostrarMedia(i); elegirModeloDeFoto(); }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { irAFoto(i); }); });
      var prev = sec.querySelector('[data-tt-prev]');
      var next = sec.querySelector('[data-tt-next]');
      if (prev) prev.addEventListener('click', function () { irAFoto(indiceActual - 1); });
      if (next) next.addEventListener('click', function () { irAFoto(indiceActual + 1); });
      if (principal) {
        var x0 = null;
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) irAFoto(indiceActual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      sec.querySelectorAll('.tt-sel').forEach(function (s) {
        var p = s.querySelector('[data-tt-continuo]');
        if (p && !p.dataset.ttListo) { p.dataset.ttListo = '1'; initContinuo(s, p); }
      });
      function marcarCopias() {
        var marcado = sec.querySelector('[data-tt-opcion] input:checked');
        sec.querySelectorAll('[data-tt-clon] label').forEach(function (lb) {
          lb.classList.toggle('tt-elegida', !!marcado && lb.htmlFor === marcado.id);
        });
      }

      function varianteSeleccionada() {
        var elegidas = [];
        sec.querySelectorAll('[data-tt-opcion]').forEach(function (g) {
          var marcado = g.querySelector('input:checked');
          elegidas.push(marcado ? marcado.value : null);
        });
        return variantes.find(function (v) {
          return v.options.every(function (o, i) { return o === elegidas[i]; });
        });
      }

      // Rapid Bundle: el coche #1 de cada oferta sigue al modelo elegido en la ficha, y al revés
      var sincronizando = false;
      function sincronizarBundle(v) {
        var nombreV = v.title || (v.options || []).join(' / ');
        sincronizando = true;
        sec.querySelectorAll('[class*="rapi-bundle-content"] .rapi-bundles__bar').forEach(function (bar) {
          var sel = bar.querySelector('select');
          if (!sel || sel.value === String(v.id)) return;
          var opt = Array.prototype.find.call(sel.options, function (o) { return o.value === String(v.id) || o.textContent.trim() === nombreV; });
          if (!opt) return;
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
        sincronizando = false;
      }
      sec.addEventListener('change', function (e) {
        var sel = e.target;
        if (sincronizando || !sel.matches || !sel.matches('[class*="rapi-bundle-content"] select')) return;
        var bar = sel.closest('.rapi-bundles__bar');
        if (!bar || bar.querySelector('select') !== sel) return;
        var nombre = sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].textContent.trim() : '';
        var radio = Array.prototype.find.call(sec.querySelectorAll('[data-tt-opcion] input'), function (i) {
          return !i.closest('[data-tt-clon]') && (i.value === nombre || i.dataset.nombre === nombre);
        });
        if (radio && !radio.checked) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
      });

      function actualizar(v) {
        sec.querySelectorAll('[data-tt-opcion]').forEach(function (g) {
          var marcado = g.querySelector('input:checked');
          var etiqueta = g.querySelector('[data-tt-valor-elegido]');
          if (etiqueta && marcado) etiqueta.textContent = marcado.dataset.nombre || marcado.value;
          marcarCopias();
          var movil = sec.querySelector('[data-tt-elegido-movil]');
          if (movil && marcado && g.id) movil.textContent = marcado.dataset.nombre || marcado.value;
        });
        if (!v) {
          if (boton) { boton.disabled = true; if (botonTexto) botonTexto.textContent = boton.dataset.textoNoDisponible || textoAgotado; }
          return;
        }
        if (inputId) inputId.value = v.id;
        sincronizarBundle(v);
        if (precio) precio.textContent = dinero(v.price);
        if (barraPrecio) barraPrecio.textContent = dinero(v.price);
        if (barraAntes) {
          var conOferta = v.compare_at_price && v.compare_at_price > v.price;
          barraAntes.hidden = !conOferta;
          if (conOferta) barraAntes.textContent = dinero(v.compare_at_price);
        }
        if (precioAntes) {
          var oferta = v.compare_at_price && v.compare_at_price > v.price;
          precioAntes.hidden = !oferta;
          if (oferta) precioAntes.textContent = dinero(v.compare_at_price);
          if (ahorro) {
            ahorro.hidden = !oferta;
            if (oferta) ahorro.textContent = (ahorro.dataset.prefijo || '') + ' ' + (ahorro.dataset.formato === 'porcentaje' ? Math.round((1 - v.price / v.compare_at_price) * 100) + '%' : dinero(v.compare_at_price - v.price).replace(/\.00(?=\D*$)/, ''));
          }
        }
        if (boton) {
          boton.disabled = !v.available;
          if (botonTexto) botonTexto.textContent = v.available ? textoComprar : textoAgotado;
        }
        if (v.featured_media && v.featured_media.id) {
          var idx = minis.findIndex(function (m) { return m.dataset.mediaId === String(v.featured_media.id); });
          if (idx > -1) mostrarMedia(idx);
        }
        if (window.history && window.history.replaceState && sec.dataset.url) {
          window.history.replaceState({}, '', sec.dataset.url + '?variant=' + v.id);
        }
      }
      sec.querySelectorAll('[data-tt-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', function () { actualizar(varianteSeleccionada()); });
      });

      var cant = sec.querySelector('[data-tt-cantidad]');
      if (cant) {
        var input = cant.querySelector('input');
        cant.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            input.value = b.dataset.paso === 'mas' ? n + 1 : Math.max(1, n - 1);
          });
        });
      }

      // Añadir al carrito sin recargar (abre el carrito lateral de Dawn)
      if (form && boton) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          var notif = document.querySelector('cart-notification');
          if (!window.fetch) return;
          // Con un bundle de Rapid Bundle activo, la app agrega los coches de la oferta elegida
          if (sec.querySelector('[class*="rapi-bundle-content"]')) return;
          e.preventDefault();
          var err = sec.querySelector('[data-tt-error]');
          if (err) err.hidden = true;
          boton.disabled = true;
          boton.setAttribute('aria-busy', 'true');
          var seccionesPedir = drawer ? 'cart-drawer,cart-icon-bubble' : (notif ? 'cart-notification-product,cart-notification-button,cart-icon-bubble' : 'cart-icon-bubble');
          var cantidad = sec.querySelector('[data-tt-cantidad] input');
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(inputId.value), quantity: cantidad ? Math.max(1, parseInt(cantidad.value, 10) || 1) : 1 }],
              sections: seccionesPedir,
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) {
                if (err) { err.textContent = res.description || res.message; err.hidden = false; }
                return;
              }
              var item = res.items ? res.items[0] : res;
              item.sections = res.sections;
              if (drawer && drawer.renderContents) {
                drawer.classList.remove('is-empty');
                drawer.renderContents(item);
              } else if (notif && notif.renderContents) {
                notif.renderContents(item);
              } else {
                window.location.href = (window.routes && window.routes.cart_url) || '/cart';
              }
            })
            .catch(function () { form.submit(); })
            .finally(function () {
              boton.removeAttribute('aria-busy');
              var v = varianteSeleccionada() || variantes[0];
              boton.disabled = v ? !v.available : false;
            });
        });
      }

      // Barra de compra fija en el móvil
      var barra = document.querySelector('[data-tt-barra]');
      if (barra && boton && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            barra.classList.toggle('tt-barra--visible', !en.isIntersecting && en.boundingClientRect.top < 0);
          });
        }).observe(boton);
        var barraBtn = barra.querySelector('button');
        if (barraBtn) barraBtn.addEventListener('click', function () {
          if (boton.disabled) { boton.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          boton.click();
        });
      }
    });
  }

  /* ---------- Barra de compra fija de la portada (móvil) ---------- */
  function initBarraHero() {
    var barra = document.querySelector('[data-tt-barra-hero]');
    var hero = document.querySelector('.tt-hero');
    if (!barra || !hero || barra.dataset.ttListo || !('IntersectionObserver' in window)) return;
    barra.dataset.ttListo = '1';
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        barra.classList.toggle('tt-barra--visible', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }).observe(hero);
  }

  /* ---------- Botón "Agregar" de las tarjetas: al carrito sin salir de la página ---------- */
  function initAgregar() {
    if (initAgregar.listo) return;
    initAgregar.listo = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-tt-agregar]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      if (!window.fetch) return;
      var drawer = document.querySelector('cart-drawer');
      var notif = document.querySelector('cart-notification');
      var texto = btn.querySelector('span');
      btn.setAttribute('aria-busy', 'true');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.ttAgregar), quantity: 1 }],
          sections: drawer ? 'cart-drawer,cart-icon-bubble' : (notif ? 'cart-notification-product,cart-notification-button,cart-icon-bubble' : 'cart-icon-bubble'),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { if (texto) texto.textContent = res.description || res.message || 'Error'; return; }
          var item = res.items ? res.items[0] : res;
          item.sections = res.sections;
          if (texto) texto.textContent = btn.dataset.textoOk || 'OK';
          btn.classList.add('tt-ok');
          setTimeout(function () { btn.classList.remove('tt-ok'); if (texto) texto.textContent = btn.dataset.texto; }, 2200);
          if (drawer && drawer.renderContents) { drawer.classList.remove('is-empty'); drawer.renderContents(item); }
          else if (notif && notif.renderContents) { notif.renderContents(item); }
          else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        })
        .catch(function () { window.location.href = '/cart'; })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  // Reseñas de Loox a escala: Loox dibuja su iframe más ancho y aquí se encoge con su altura real
  function initLooxEscala(root) {
    root.querySelectorAll('[data-tt-loox-escala]').forEach(function (caja) {
      if (caja.dataset.ttListo) return;
      caja.dataset.ttListo = '1';
      var ajustar = function () {
        var f = caja.querySelector('iframe');
        if (!f || !f.offsetWidth) return;
        var e = f.getBoundingClientRect().width / f.offsetWidth;
        var h = Math.ceil(f.offsetHeight * e) + 'px';
        if (caja.style.height !== h) caja.style.height = h;
      };
      new MutationObserver(ajustar).observe(caja, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      window.addEventListener('resize', ajustar);
      ajustar();
    });
    // Recorte con botón "Ver más reseñas": se oculta si todo cabe en el alto visible
    root.querySelectorAll('[data-tt-recorte]').forEach(function (caja) {
      if (caja.dataset.ttRecorteListo) return;
      caja.dataset.ttRecorteListo = '1';
      var loox = caja.querySelector('.tt-resenas__loox');
      var btn = caja.querySelector('[data-tt-ver-mas]');
      var revisar = function () {
        if (!loox || caja.classList.contains('tt-abierto')) return;
        var alto = parseFloat(loox.style.height) || loox.scrollHeight;
        caja.classList.toggle('tt-sin-mas', alto <= loox.clientHeight + 4);
      };
      if (btn) btn.addEventListener('click', function () { caja.classList.add('tt-abierto'); });
      if (loox) new MutationObserver(revisar).observe(loox, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
      window.addEventListener('resize', revisar);
      revisar();
    });
  }

  function initTodo(root) {
    initAgregar();
    initBarraHero();
    initReveal(root);
    initCifras(root);
    initParallax(root);
    initCarrusel(root);
    initPasos(root);
    initProducto(root);
    initLooxEscala(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }
  // Editor de Shopify: re-inicializa al añadir o editar secciones
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
